import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './crowdfunding_image_preview.less'
import Hammer from 'react-hammerjs'
import Strip from 'components/strip'
import { Link, CaptionText } from '@paypalcorp/pp-react'
import ImageFileField from 'components/common/image_file_field'
import { getI18n } from 'client/i18n'
import { inverseLerp } from 'shared/helpers/math_helpers'
import { COVER_IMAGE_MAX_TOTAL_SIZE } from 'shared/shared_consts'

export const DEFAULT_RELATIVE_PAN = 50

const i18n = getI18n('components/crowdfunding_image_preview')

class CrowdFundingImagePreview extends React.Component {
  static propTypes = {
    imageUrl: PropTypes.string.isRequired,
    pan: PropTypes.number,
    onPanChange: PropTypes.func,
    onImageChange: PropTypes.func,
    onImageLoad: PropTypes.func,
    onImageRemove: PropTypes.func,
  }

  state = {
    pan: this.props.pan,
    imageUrl: this.props.imageUrl,
  }

  componentDidMount() {
    this.refreshImageSize()
  }

  refreshImageSize = () => {
    let image = new Image()
    image.addEventListener('load', () => {
      this.imageWidth = image.width
      this.imageHeight = image.height
      this.previewWidth = this.strip.offsetWidth
      this.previewHeight = this.strip.offsetHeight
      this.previewZoom = this.previewWidth / this.imageWidth
    })
    image.src = this.state.imageUrl
  }

  handleImageChangeIntent = () => {
    this.imageInput.handleOpenFileDialog()
  }

  handleImageChange = val => {
    this.setState(
      {
        pan: DEFAULT_RELATIVE_PAN,
        imageUrl: val.url,
      },
      () => {
        this.refreshImageSize()
      }
    )
    this.props.onImageChange(val)
  }

  handlePanStart = () => {
    this.panStart = this.lastAbsolutePan || 0
  }

  handlePan = evt => {
    let remainingHeight =
      (this.previewZoom * this.imageHeight - this.previewHeight) / 2
    let absolutePan = this.panStart + evt.deltaY
    absolutePan = Math.min(
      Math.max(-remainingHeight, absolutePan),
      remainingHeight
    )
    let relativePan = Math.round(
      inverseLerp(remainingHeight, -remainingHeight, absolutePan) * 100
    )
    this.lastAbsolutePan = absolutePan
    this.setState({ pan: relativePan })
  }

  handlePanEnd = () => {
    this.props.onPanChange(this.state.pan)
  }

  render() {
    // TODO Figure out a way to do this in scalable way.
    const customStyle = {
      height: '201px',
    }

    return (
      <Hammer
        onPanStart={this.handlePanStart}
        onPan={this.handlePan}
        onPanEnd={this.handlePanEnd}
        options={{ recognizers: { pan: { threshold: 0 } } }}
      >
        <div styleName="preview-container">
          <CaptionText styleName="drag">
            <span> {i18n('drag_image')}</span>
          </CaptionText>
          <div>
            <Strip
              isResponsive={true}
              backgroundImage={this.state.imageUrl}
              backgroundPan={this.state.pan}
              customStyle={customStyle}
              stripRef={strip => {
                this.strip = strip
              }}
            />
          </div>
          <div styleName="actions">
            <Link
              data-pa-click="changeImage"
              href="javascript:;"
              styleName="action"
              onClick={this.handleImageChangeIntent}
            >
              {i18n('change_image')}
            </Link>

            <Link
              data-pa-click="removeImage"
              href="javascript:;"
              styleName="action"
              onClick={this.props.onImageRemove}
            >
              {i18n('remove_image')}
            </Link>
          </div>
          <ImageFileField
            ref={imageInput => {
              this.imageInput = imageInput
            }}
            onImageLoad={this.props.onImageLoad}
            restrictedTotalSize={COVER_IMAGE_MAX_TOTAL_SIZE}
            onChange={this.handleImageChange}
          />
        </div>
      </Hammer>
    )
  }
}

export default cssModules(CrowdFundingImagePreview, styles)
